import {useReducers, UseReducersReturnValue} from '@wallaby-ui/core';
import {useRef} from 'react';

import {getReducers} from 'src/js/containers/grid/grid_reducers';

export function useGridReducers(
  gridId: string,
  hasApiState: boolean
): UseReducersReturnValue {
  const reducersRef = useRef<Record<string, any>>(
    getReducers(gridId, hasApiState)
  );

  return useReducers(reducersRef.current);
}
